import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoginService } from '@app/login.service';
import { ApiService } from '@app/services/api/api.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-explore-mobile',
  templateUrl: './explore-mobile.component.html',
  styleUrls: ['./explore-mobile.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, FormsModule, RouterModule],
})
export class ExploreMobileComponent {
  public exploring = false;
  public searchForm!: FormGroup;
  public properties$!: BehaviorSubject<any[]>;

  @Output()
  public propertiesChange = new EventEmitter<any[]>();

  public activeInput: string | undefined;

  constructor(
    private readonly apiService: ApiService,
    private readonly loginService: LoginService
  ) {}

  ngOnInit() {
    this.properties$ = this.apiService.properties;
  }

  startExploring() {
    this.loginService.showLogin();
  }

  public explore(input: string) {
    this.exploring = true;
    this.activeInput = input;
    // this.router.navigateByUrl('');
  }
}
